import React from 'react';

interface State {}

const OrdersReceiptPage = () => {
  return <>OrdersReceiptPage</>;
};

export default OrdersReceiptPage;
